import { render } from "./CookiesFunctionalTableGeneralField.vue?vue&type=template&id=612d1516&scoped=true&ts=true"
import script from "./CookiesFunctionalTableGeneralField.vue?vue&type=script&lang=ts"
export * from "./CookiesFunctionalTableGeneralField.vue?vue&type=script&lang=ts"

import "./CookiesFunctionalTableGeneralField.vue?vue&type=style&index=0&id=612d1516&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-612d1516"]])

export default __exports__